import { render, staticRenderFns } from "./Consultas.vue?vue&type=template&id=3febc7c5"
import script from "./Consultas.vue?vue&type=script&lang=js"
export * from "./Consultas.vue?vue&type=script&lang=js"
import style0 from "./Consultas.vue?vue&type=style&index=0&id=3febc7c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports